import { useState } from "react";
import { useUploadImage } from "./useUploadImage.ts";

export const useUploadMultipleImages = ({
  onAllImagesUploaded,
  describeImage = false,
  maxSize = 10000,
  pipelineCompatible = true,
}: {
  onAllImagesUploaded?: (imageUuids: string[]) => void;
  describeImage?: boolean;
  maxSize?: number;
  pipelineCompatible?: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { mutate: upload } = useUploadImage({
    describeImage,
    maxSize,
    pipelineCompatible,
  });

  const mutate = async ({ images }: { images: Blob[] }) => {
    setIsLoading(true);

    try {
      const imageUuids: string[] = [];

      for (const image of images) {
        const uuid = await new Promise<string>((resolve) => {
          upload({
            image,
            onMutateSuccess: resolve,
          });
        });

        imageUuids.push(uuid);
      }

      onAllImagesUploaded?.(imageUuids);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    mutate,
    isLoading,
  };
};
